export const FORM_FIELD_NAMES = {
    MOBILE_URLS : "mobileUrlIds",
}